import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const mascot = {
  fetchMascot: lazyModuleMethod(() => import('./fetchMascot'), 'default'),
  updateMascot: lazyModuleMethod(() => import('./updateMascot'), 'default'),
}
